(() => {
  window.revaaCardVariantSyncLoaded = true;
  const synchroniseCardVariant = (variantSelects) => {
    const variantsJson = variantSelects.dataset.cardVariants;
    const form = document.getElementById(`product-form-${variantSelects.dataset.section}-${variantSelects.dataset.productId}`);

    if (!variantsJson || !form) return;

    const selectedOptions = [...variantSelects.querySelectorAll('fieldset')]
      .map((fieldset) => fieldset.querySelector('input:checked')?.value)
      .filter(Boolean);
    const variant = JSON.parse(variantsJson).find((item) => item.options.every((option, index) => option === selectedOptions[index]));

    variantSelects.querySelectorAll('fieldset').forEach((fieldset, index) => {
      const selectedValue = fieldset.querySelector('[data-selected-value]');
      if (selectedValue && selectedOptions[index] !== undefined) {
        selectedValue.textContent = selectedOptions[index];
      }
    });

    const card = variantSelects.closest('product-info');
    const mediaId = variant?.featured_media?.id;
    const mediaItems = card?.querySelectorAll('.card__media .product__media-item');
    if (mediaItems?.length && mediaId) {
      const selectedMedia = Array.from(mediaItems).find((media) => (media.dataset.mediaId || '').endsWith('-' + mediaId));
      if (selectedMedia) {
        mediaItems.forEach((media) => {
          media.style.display = media === selectedMedia ? 'block' : 'none';
        });
      }
    }
    const variantInput = form.querySelector('.product-variant-id');
    const addToCartButton = form.querySelector('[name="add"]');

    if (variantInput) {
      variantInput.value = variant?.id || '';
      variantInput.disabled = !variant || !variant.available;
    }

    if (addToCartButton) addToCartButton.disabled = !variant || !variant.available;
  };

  const initialiseCardVariantSync = () => {
    const scheduleSynchronisation = (variantSelects) => {
      window.setTimeout(() => synchroniseCardVariant(variantSelects), 25);
    };

    document.addEventListener('click', (event) => {
      const label = event.target.closest('label[for], label[aafor]');
    const nestedRadio = label?.querySelector('input[type="radio"]');
    if (nestedRadio && !nestedRadio.checked) {
      nestedRadio.checked = true;
      nestedRadio.dispatchEvent(new Event('change', { bubbles: true }));
    }
      const variantSelects = label?.closest('variant-selects[data-layout="card"]');
      if (variantSelects) scheduleSynchronisation(variantSelects);
    }, true);

    document.addEventListener('change', (event) => {
      const variantSelects = event.target.closest('variant-selects[data-layout="card"]');
      if (variantSelects) scheduleSynchronisation(variantSelects);
    }, true);

    window.setTimeout(() => document.querySelectorAll('variant-selects[data-layout="card"]').forEach(synchroniseCardVariant));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialiseCardVariantSync);
  } else {
    initialiseCardVariantSync();
  }

  window.addEventListener('load', initialiseCardVariantSync);
})();
